import { createPerfilApiClient, getPerfilCredentials } from './perfilApiClient';

export default {
    /**
     * Obtiene los movimientos del monedero del perfil autenticado.
     * Devuelve la lista cruda del backend sin inventar campos.
     *
     * @returns {Promise<Array>}
     */
    async getMonedero() {
        try {
            const { token, hashTeatro } = getPerfilCredentials();

            const response = await createPerfilApiClient().get('/f/perfil/monederos', {
                params: {
                    filters: {},
                    api_key: token,
                    ...(hashTeatro ? { tid: hashTeatro } : {}),
                },
            });

            const data = response.data ?? {};
            const rawItems = data.monederos ?? data.data ?? data.items ?? [];

            return Array.isArray(rawItems) ? rawItems : [];
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[monedero] Error al obtener movimientos:', error);
            }
            throw error;
        }
    },
};
